import { AutenticacionService } from './autenticacion.service';
import { Http, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';
import { ConstantsService } from './constants.service';

@Injectable()
export class ReportePorInversionistaService {
  public api_url: string;
  public modulo_url: string;
  public service_url: string;
  constructor(private http: Http, private authService: AutenticacionService, private constantService: ConstantsService) {
    this.api_url = this.constantService.apiURL;
    this.modulo_url = '/reportes/reporte-por-inversionista';
    this.service_url = this.api_url + this.modulo_url;
  }

  public getDefaultSchedule() {
    return {
      'obras': {},
      'totales': [],
      'movimientos':{}
    };
  }

  getInversionistas(){
    return this.http.get(this.service_url + '/inversionistas', this.authService.getAuthHeaders());
  }

  getObrasByInversionista(idInversionista) {
    return this.http.get(this.service_url + '/inversionistas/' + idInversionista + '/obras', this.authService.getAuthHeaders());
  }

  getReporte(inversionista, fecha, obra) {
    let idInversionista = inversionista.idInversionistas;

    if (obra && obra.idObras) {
      let idObra = obra.idObras;
      return this.http.get(this.service_url + '/generar?fecha=' + fecha + '&inversionista=' + idInversionista + '&obra=' + idObra , this.authService.getAuthHeaders());  
    }
    return this.http.get(this.service_url + '/generar?fecha=' + fecha + '&inversionista=' + idInversionista, this.authService.getAuthHeaders());
  }

  public getImageUrl(id) {
    const options = this.authService.getAuthHeaders();
    options.responseType = ResponseContentType.Blob;
    return this.http.get(this.api_url + '/reportes/obras/imagen?id=' + id, options);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/reporte-por-inversionista.service.ts